import useSelectInput from '@/core/hooks/inputs/useSelectInput/useSelectInput';

export default useSelectInput;
